import { Component } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { NavController, NavParams, ToastController } from "ionic-angular";
import { AlertController, LoadingController } from "ionic-angular";
import { Observable } from "rxjs/Observable";
import { Member } from "../../models/interfaces/member.model";
import { Status } from "../../models/interfaces/status.model";
import { MemberPage } from "../../pages/member/member";
import { AuthService } from "../../providers/dbservice/authservice";
import { DbserviceProvider } from "../../providers/dbservice/dbservice";
import { ValidationserviceProvider } from "../../providers/dbservice/validationservice";
import { ConfigService } from '../../providers/dbservice/configservice';

@Component({
  selector: "page-member_add",
  templateUrl: "member_add.html",
})
export class MemberAddPage {
  private loading: any;
  private status$;
  private member$: Observable<Member[]>;
  private memberForm: FormGroup;
  private member: Member;
  private styleName: string ="";
  constructor(private configService: ConfigService,public authService: AuthService, public navCtrl: NavController, public navParams: NavParams,
    private formBuilder: FormBuilder, private toastCtrl: ToastController,
    private db: DbserviceProvider, public alertCtrl: AlertController, public loadingCtrl: LoadingController,
  ) {
    console.log("MemberAddPage constructor");
    this.styleName=this.configService.getConfig("STYLENAME");
    this.memberForm = this.formBuilder.group({
      "mb_birthdate": ["", [Validators.required]],
      "mb_contact_mobile": ["+65", [Validators.required, ValidationserviceProvider.phoneValidator]],
      "mb_email_id": ["", [Validators.required, ValidationserviceProvider.emailValidator]],
      "mb_firstname": ["", [Validators.required]],
      "mb_gender": [""],
      "mb_hashname": ["", [Validators.required]],
      "mb_lastname": ["", [Validators.required]],
      "mb_password": ["pass4321@", [Validators.required]],
      "mb_photo": ["assets/imgs/member/shhh-def.jpg"],
      "rc_name": [""],
      "st_id": ["2", [Validators.required]],
    });
  }
  private ionViewWillEnter() {
    console.log("MemberAddPage ionViewWillEnter");
    this.onInitPage();
  }

  private onInitPage() {
    console.log("MemberAddPage onInitPage");
    this.status$ = this.db.dbCol({
      "action": "select", "mapObject": "status",
      "sqlExtended": " order by st_order",
    });
  }

  private goback() {
    console.log("MemberAddPage goback");
    this.navCtrl.pop();
  }

  private addMember() {
    console.log("MemberAddPage addMember");
    if (this.memberForm.dirty && this.memberForm.valid) {

      var dt = new Date().getTime();
      var uuid = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (dt + Math.random() * 16) % 16 | 0;
        dt = Math.floor(dt / 16);
        return (c == 'x' ? r : (r & 0x3 | 0x8)).toString(16);
      });

      this.db.dbCol({ "action": "register", "mapObject": "member", ...this.memberForm.value, ...{ "mb_password_reset_hash": uuid } })
        .subscribe((ret3) => {
          this.navCtrl.pop();
        });
    }
  }


  private ngOnDestroy() {
    console.log("MemberAddPage ngOnDestroy");
  }
}



// WEBPACK FOOTER //
// ./src/pages/member/member_add.ts